import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Stop being so fucking productive",
  "description": "",
  "published": "2011-12-06T00:00:00.000Z",
  "redirect_from": ["/blog/stop-being-so-fucking-productive/swizec/3124"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/300px-William_Fettes_Douglas_-_The_Alchemist1.jpg",
        "alt": "\"The Alchemist\" by William Fettes Do...",
        "title": "\"The Alchemist\" by William Fettes Do..."
      }}></img></p>
    <p>{`Productivity is a big thing in my part of the universe. Everyone thinks they've cracked the secret for turning time into gold. Modern day alchemists, the lot of us.`}</p>
    <p>{`This gives us a pervasive culture of 20-somethings busting their backs to squeeze every last ounce of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Productivity",
        "title": "Productivity"
      }}>{`productivity`}</a>{` out of their day. Sleep, sex, health and culture be damned! If you condense your whole working life into five years of a startup you'll be rich didn't you know? Then everything will be alright!`}</p>
    <p>{`I have this deeply seated hunch that it won't be alright. You'll never be a 20-something again. Ever seen a top athlete when they hit 35? They can barely walk, if they're lucky they get to train a bunch of 20-somethings, but more often than not they just sort of wither away and nobody hears of them again.`}</p>
    <p>{`You're doing that to your brain.`}</p>
    <p>{`But with mental tasks productivity doesn't increase linearly with time worked. Every hour spent working hard is a tax on the next hour you want to spend working hard. And so on until you can spend hours, even days, working without achieving.`}</p>
    <p>{`Remember the quote "You speak a lot, but you don't say much"? Same goes for working a lot.`}</p>
    <p>{`A couple weeks ago an article titled `}<em parentName="p"><a parentName="em" {...{
          "href": "http://calnewport.com/blog/2011/11/11/if-youre-busy-youre-doing-something-wrong-the-surprisingly-relaxed-lives-of-elite-achievers/"
        }}>{`If you're busy, you're doing something wrong`}</a></em>{` floated around the internets. It was about a study comparing the crème de la crème of violinists at an elite school in Germany with those that are just the crème.`}</p>
    <p>{`Think of it like comparing `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Ayrton_Senna"
      }}>{`Senna`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Michael_Schumacher"
      }}>{`Schumacher`}</a>{`. `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Isaac_Newton"
      }}>{`Newton`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Feynman"
      }}>{`Feyman`}</a>{`. Even `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Alan_Turing",
        "title": "Alan Turing"
      }}>{`Turing`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Linus_Torvalds"
      }}>{`Torvalds`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/300px-AlanTuring-Bletchley3.jpg",
        "alt": "Nederlands: Leistenen beeld van Allan Turing, ...",
        "title": "Nederlands: Leistenen beeld van Allan Turing, ..."
      }}></img></p>
    <p>{`The study found that despite putting in the same amount of measurable work (hours spent) those at the very top report being significantly less busy than those who are merely near the top. They also report having heaps of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Leisure",
        "title": "Leisure"
      }}>{`free time`}</a>{` and generally having a rather easygoing lifestyle.`}</p>
    <p>{`And yet, they significantly outperform those who are constantly busy and under pressure.`}</p>
    <p>{`With this in mind I started looking for ways of fighting being busy. The first thing I noticed was that under crunch time Itend to do a little bit of everything every day. Two hours on this project, three hours of school and so on.`}</p>
    <p>{`Makes me `}<em parentName="p">{`feel`}</em>{` super productive! Moving forward on every project every day. How much better than that can you get?`}</p>
    <p>{`But the reality is that `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Context_switch",
        "title": "Context switch"
      }}>{`context switching`}</a>{` presented significant overhead and while I felt productive, I was actually just wearing myself out and producing ever worse amounts of crap.`}</p>
    <p>{`So for the past few weeks I've only been working on a single project every day. Some days are reserved for school, some are reserved for freelancing and so on. This way I can go about my weeks in a pretty relaxed manner, even managing to have a decent social life, while still getting everything done!`}</p>
    <p>{`It's amazing. I heartily suggest you try it.`}</p>
    <p>{`But this is all just talk. I don't have anything other than `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Anecdotal_evidence",
        "title": "Anecdotal evidence"
      }}>{`anecdotal evidence`}</a>{` to support my findings, so next week I am starting a four week one-man study trying to find the link between mental agility and being busy. I want cold hard numbers supporting this hypothesis.`}</p>
    <p>{`If you want to help with the study to get a better sample, I'm all ears for volunteers ;)`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://rsastories.wordpress.com/2011/10/22/how-long-does-it-take-to-context-switch/"
        }}>{`How long does it take us to context switch?`}</a>{` (rsastories.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//www.cbc.ca/news/canada/new-brunswick/story/2011/10/13/nb-higgs-arseneault-social-assistance-rates-519.html%3Fcmp%3Drss&a=58248414&rid=f9acf072-bd0c-40f6-a350-e520fc305149&e=3a2432c8eb1fd8d7f4cf37b2ef5f2444"
        }}>{`Higgs under fire for questioning welfare rates`}</a>{` (cbc.ca)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/how-your-office-hurts-productivity-2011-11"
        }}>{`Here's How Much Your Dingy Office Is Hurting Productivity`}</a>{` (businessinsider.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wiki.answers.com/Q/Are_any_alchemist_still_alive"
        }}>{`Are any alchemist still alive`}</a>{` (wiki.answers.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=f9acf072-bd0c-40f6-a350-e520fc305149",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      